
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DispatchOrder, DispatchOrderCreate } from './dispatch-order';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class DispatchOrderService {
    constructor(private http: HttpClient) {
    }
    token = environment.token;
    dourl = environment.appURL + "/dispatchorders";


    //  GET ALL DISPATCH
    getDispatchOrders() { return this.http.get<DispatchOrder[]>(this.dourl, { headers: new HttpHeaders({ "Authorization": "Bearer " + this.token }) }).pipe(tap(_ => { }), catchError(this.handleError('getDispatchOrders', []))); }


    //  GET ALL DISPATCH
    getDispatchOrdersCl(client: number) { return this.http.get<DispatchOrder[]>(this.dourl + "?client=" + client, { headers: new HttpHeaders({ "Authorization": "Bearer " + this.token }) }).pipe(tap(_ => { }), catchError(this.handleError('getDispatchOrders', []))); }

    //  Change Dispatch Order STATE
   changeState(dispatchId: number, stateID: number) {
        var upd = this.statusStr(stateID);
        var urlcommand = this.dourl + "/" + dispatchId;
        return this.http.put(urlcommand, upd, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) });
    }
    statusStr(id: number): string {
        return "{\"dispatchstate\":\"" + id + "\" }";
    }

    //  Change Dispatch Order STATE
    saveNote(dispatchId: number, note: string) {
        var upd = "{\"note\":\"" + note + "\" }";
        var urlcommand = this.dourl + "/" + dispatchId;
        return this.http.put(urlcommand, upd, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) });
    }

    //  GET DISPATCH ORDER BY ID QL
    getDispatchOrder(id: number) {
        var query = "{dispatchorder(id:" + id + " ){ id client{id, name} note machines{ id, shortname, serialnumber, modelnumber, state{ statevalue} , machinetype{id type}} details date  user{id , username} trackings{id, shipper, trackingnumber, date, user{username},  trackingstate{id, state} }   dispatchitems{id fixcats{id cat} details machine{id shortname serialnumber state{statevalue} machinetype{id type} } }  fixcats{id, cat}, dispatchstate{id , state}  }}";
        const url = environment.graphURL + query;
        return this.http.get<DispatchOrder>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['dispatchorder']));
    }

    //  GET DISPATCH ORDER BY ID QL
    getDispatchOrderQL(id: number) {
        var query = "{dispatchorder(id:" + id + " ){ id client{id, name} note machines{ id, shortname, serialnumber, modelnumber, state{ statevalue} , machinetype{id type}} details date  user{id , username} trackings{id, shipper, trackingnumber, date, user{username},  trackingstate{id, state} }   dispatchitems{id fixcats{id cat} details machine{id shortname serialnumber state{statevalue} machinetype{id type} } }  fixcats{id, cat}, dispatchstate{id , state}  }}";
        const url = environment.graphURL + query;
        return this.http.get<DispatchOrder[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['dispatchorder']));
    }

    //  POST DISPATCH ORDER / Create
    createDispatchOrder(dio: DispatchOrderCreate) {
        var upd = JSON.stringify(dio);
        return this.http.post<DispatchOrder>(`${environment.appURL}/dispatchorders/`, upd, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) });
    }

    //  GET DISPATCH ORDER BY CRITERIA
    getDispatchOrderByCriteria(criteria: string, argument: string) {
        const url = this.dourl + "?" + criteria + "_contains=" + argument;
        return this.http.get<DispatchOrder[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(tap(_ => { }), catchError(this.handleError('geMachineByShortname', [])));
    }

    //  GET DISPATCH ORDER BY CRITERIA AND CLIENT GRAPHQL
    getDispatchOrderByCriteriaClient(criteria: string, argument: string, clientId: number) {
        var query = "{ dispatchorders(where: { id: \"" + argument + "\", client: \"" + clientId + "\" }) { id client { id name } note machines { id shortname serialnumber modelnumber state { statevalue } } details date user { id username } trackings { id shipper trackingnumber date user { username } trackingstate { id state } } dispatchstate { id state } } }"
        const url = environment.graphURL + query;
        return this.http.get<DispatchOrder[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['dispatchorders']));
    }

    //  GET DISPATCH ORDER BY CLIENT ID GRAPHQL
    getClientDispatchOrders(clientId: number) {
        var query = "{dispatchorders (where:{ client:" + clientId + "}){ id client{id, name} note machines{ id, shortname, serialnumber, modelnumber, state{ statevalue}} details date  user{id , username} trackings{id, shipper, trackingnumber, date, user{username},  trackingstate{id, state} }  dispatchstate{id , state} }}";
        const url = environment.graphURL + query;
        return this.http.get<DispatchOrder>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['dispatchorders']));
    }

    //  GET DISPATCH ORDER BY CRITERIA GRAPHQL
    getDispatchOrdersByCriteriaQl(criteria: string, argument: string) {
        var query = "{dispatchorders (where:{" + criteria + "_contains:\"" + argument + "\"}){ client{name} user{username firstname lastname} observer{id firstname lastname username} id note machines { id shortname client{name}} errorcode title status{id status} dateofticket dateresolved resolution }}"
        const url = environment.graphURL + query;
        return this.http.get<DispatchOrder[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['dispatchorders']));
    }

    //  GET DISPATCH ORDER BY Machine Serial Number & Client Optional Filter
    getDispatchOrdersByMachineSerialNumberQl(argument: string, client?: number) {
        if (client == undefined) {
            var query = "{ dispatchorders(where: { machines: { serialnumber_contains: \"" + argument + "\" } }) { id client { id name } machines { id shortname serialnumber modelnumber state { statevalue } } details date user { id username } trackings { id shipper trackingnumber date user { username } trackingstate { id state } } dispatchstate { id state } } }"
        } else {
            var query = "{ dispatchorders(where: { machines: { serialnumber_contains: \"" + argument + "\"}, client: { id:  \"" + client + "\" } }) { id client { id name } machines { id shortname serialnumber modelnumber state { statevalue } } details date user { id username } trackings { id shipper trackingnumber date user { username } trackingstate { id state } } dispatchstate { id state } } }"
        }
        const url = environment.graphURL + query;
        return this.http.get<DispatchOrder[]>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['dispatchorders']));
    }

    //  DELETE DISPATCH ORDER BY ID
    deleteDispatchOrder(id: number): Observable<any> { return this.http.delete<DispatchOrder>(`${this.dourl}/${id}`, { headers: new HttpHeaders({ "Authorization": "Bearer " + this.token }) }).pipe(tap(_ => { }), catchError(this.handleError('getDispatchOrders', []))); }

    //  ERROR HANDLING
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            console.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
}
